import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';
import { InstrumentSearchEnabled } from '../../entities/instrument-search-enabled.entity';

@Injectable({
  providedIn: 'root',
})
export class InstrumentSearchEnabledService {
  private readonly _endpoint = `${environment.apihost}/api/instrumentsearchenabled`;

  constructor(private _http: HttpClient) {}

  public isEnabled = async (customerId: string): Promise<boolean> => {
    try {
      return (await firstValueFrom(this._http.get<InstrumentSearchEnabled>(`${this._endpoint}?customerId=${customerId}`)))?.enabled;
    } catch (e) {
      return false;
    }
  };
}
